export const QUERY_KEYS = {
  profile: "profile",
  addresses: "addresses",
  offlinePurchases: "offlinePurchases",
  devices: "devices",
  customAttributes: "getCustomAttributes",
  authenticationValidation: "authenticationValidation",
  authenticationStrategies: "authenticationStrategies",
  registrationPublicConfiguration: "registrationPublicConfiguration",
  passwordRules: "passwordRules",
  ageVerificationHidden: "isAgeVerificationHidden",
  avpAvailableMethods: "avpAvailableMethods",
  loyaltyStatus: "loyaltyStatus",
  loyaltyPrize: "loyaltyPrize",
  loyaltyPrizes: "loyaltyPrizes",
  loyaltyRewardFilters: "loyaltyRewardFilters",
  earnedPoints: "earnedPoints",
  loyaltyAchievements: "loyaltyAchievements",
  usersPointsBalance: "usersPointsBalance",
  providerCodes: "providerCodes",
  referralStatus: "referralStatus",
  referralStats: "referralStats",
  referralCustomer: "referralCustomer",
  cardData: "cardData",
  userSubscription: "userSubscription",
  invoiceUrl: "invoiceUrl",
  consentPurposes: "consentPurposes",
  consentPurposesByStep: "consentPurposesByStep",
  userConsents: "userConsents",
  deviceRegistrationStatus: "deviceRegistrationStatus",
  surveysStatus: "surveysStatus",
  pgsClient: "pgsClient",
  tradeInEligibility: "tradeInEligibility",
  tradeInConfiguration: "tradeInConfiguration",
  tradeInDevices: "tradeInDevices",
} as const;
export const MUTATION_KEYS = {
  createAddress: "createAddress",
  updateAddress: "updateAddress",
  deleteAddress: "deleteAddress",
  deleteDevice: "deleteDevice",
  setDefaultShipping: "setDefaultShipping",
  updateCustomAttributes: "updateCustomAttributes",
  logout: "logout",
  forgotPassword: "forgotPassword",
  changePassword: "changePassword",
  updateEmail: "updateEmail",
  updatePhone: "updatePhone",
  avpVerify: "avpVerify",
  avpInitAsyncVerification: "avpInitAsyncVerification",
  sendOTC: "sendOTC",
  sendLoginOTC: "sendLoginOTC",
  sendEmailOTC: "sendEmailOTC",
  checkPhone: "checkPhone",
  updateAgeVerification: "updateAgeVerification",
  updatePersonalData: "updatePersonalData",
  unregister: "unregister",
  deactivateAccount: "deactivateAccount",
  register: "register",
  registerDevice: "registerDevice",
  assignDeviceToUser: "assignDeviceToUser",
  login: "login",
  resetConsumerPassword: "resetConsumerPassword",
  verifyConsumer: "verifyConsumer",
  verifyEmailUpdate: "verifyEmailUpdate",
  verifyReferralCode: "verifyReferralCode",
  updateReferralCode: "updateReferralCode",
  magicLinkLogin: "magicLinkLogin",
  orderCancellation: "orderCancellation",
  requestCoupon: "requestCoupon",
  platformValidation: "platformValidation",
  startSurvey: "startSurvey",
  validateSurveySerialCode: "validateSurveySerialCode",
  purchaseLoyaltyPrize: "purchaseLoyaltyPrize",
  updateUserSubscription: "updateUserSubscription",
  resumeUserSubscription: "resumeUserSubscription",
  updateConsentPurposes: "updateConsentPurposes",
  subscribeUser: "subscribeUser",
  unsubscribeUserFully: "unsubscribeUserFully",
  unsubscribeUser: "unsubscribeUser",
  verifyOtp: "verifyOtp",
  verifyEmailOtp: "verifyEmailOtp",
  checkValidationStatus: "checkValidationStatus",
  initPhoneValidationByOtp: "initPhoneValidationByOtp",
} as const;
